<template>
  <div>
    <!-- 视频组件 -->
    <el-row style="display: flex">
      <template v-for="index in 5">
        <VideoUpload
          v-if="index <= self_form.videos.length"
          :key="self_form.videos[index - 1].videoId"
          @upload-success="videoUploadSuccess"
          @changeTagType="video => changeVideoType(video, index - 1)"
          :video="self_form.videos[index - 1]"
          :options="tagOptions"
          @del="video => videoDel(video, index - 1)"
          aspectRatio="1:1,3:4,9:16"
          :limitDuration="300"
          :multiple="!!props.multiple"
        />
        <!-- <VideoUpload
          v-if="index <= self_form.videos.length + 1"
          :key="index"
          @upload-success="videoUploadSuccess"
          @changeTagType="video => changeVideoType(video, index - 1)"
          :video="self_form.videos[index - 1]"
          :options="tagOptions"
          @del="video => videoDel(video, index - 1)"
          aspectRatio="1:1,3:4,9:16"
          :limitDuration="300"
          :multiple="!!props.multiple"
        /> -->
      </template>
      <VideoUpload
          v-if="self_form.videos.length < 5"
          @upload-success="videoUploadSuccess"
          :video="null"
          :options="tagOptions"
          aspectRatio="1:1,3:4,9:16"
          :limitDuration="300"
          :multiple="!!props.multiple"
        />
    </el-row>
    <el-row style="font-size: 12px; margin-top: 10px">
      <el-col>分辨率 >= 300p；时长上限为五分钟；宽高比支持1:1、3:4、9:16，最多上传五个</el-col>
      <el-col>视频格式：mp4、mov、m4v、flv、x-flv、wmv、rm、3gp、avi</el-col>
    </el-row>
  </div>
</template>

<script>
import storeMixins from '../store-mixins';
import VideoUpload from '@/components/Uploads/videoUploadWithTagType.vue';

export default {
  mixins: [storeMixins],
  props: ['props'],
  data() {
    return {
      self_form: {
        videos: [],
      },
    };
  },
  components: {
    VideoUpload,
  },
  computed: {
    key() {
      return this.props.name;
    },
    tagOptions() {
      const children = this.props.dataSource?.children || [];
      return children.find(item => item.name === 'videoType')?.options || [];
    },
  },
  mounted() {
    this.self_form.videos = this.tbForm?.auctionVideos || [];
  },
  methods: {
    // 转换数据格式的方法
    formatVideoData(videoList) {
      return videoList.map(video => {
        // 只保留需要的字段
        return {
          videoTips: video.videoTips,
          videoType: video.videoType,
          videoId: video.videoId,
          videoInfoJson: video,
        };
      });
    },
    // 生成唯一性videoId
    generateUniqueVideoId() {
      return `VID_${Date.now()}_${Math.random().toString(36).substring(2, 8)}`.toUpperCase();
    },
    // 统一同步表单方法
    syncForm(videoList) {
      const formattedData = this.formatVideoData(videoList);
      this.updateTbForm({ [this.key]: formattedData });
    },
    // 视频上传成功
    videoUploadSuccess(video) {
      if (this.self_form.videos.length < 5) {
        this.self_form.videos.push({ ...video, videoId: this.generateUniqueVideoId(), videoType: this.tagOptions[0].value });
        this.syncForm(this.self_form.videos);
      }
    },
    // 删除视频
    videoDel(video, index) {
      this.self_form.videos.splice(index, 1);
      this.syncForm(this.self_form.videos);
    },
    // 修改视频标签
    changeVideoType(video, index) {
      this.self_form.videos[index].videoType = video.videoType;
      this.syncForm(this.self_form.videos);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>